import React from 'react'
import ReactDOM, {  } from 'react-dom'
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store'
import './assets/css/custom.css';

//import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';

import './i18n';
import App from './App'
import { initRum } from './utils/rum';
import RumErrorBoundary from './components/RumErrorBoundary';

// Initialize AWS CloudWatch RUM monitoring
initRum();

// DEV ONLY. The QBO OAuth callback must be publicly reachable, so in local dev it
// arrives on a tunnel origin (ngrok) — but the auth token lives in localStorage
// under the localhost origin, which is a different origin entirely. Bounce to
// localhost, carrying the OAuth query params.
//
// This has to happen HERE, before React renders: /quickbook-callback sits inside
// <PrivateRoutes>, so the auth guard redirects an unauthenticated visitor to
// /login before QuickBookCallback ever mounts — which is why the equivalent check
// inside that component never ran.
//
// REACT_APP_LOCAL_DEV_PORT is unset in every deployed environment, so this is inert
// outside local dev.
const localDevPort = process.env.REACT_APP_LOCAL_DEV_PORT;
if (
  localDevPort
  && window.location.hostname !== 'localhost'
  && window.location.pathname === '/quickbook-callback'
) {
  window.location.replace(
    `http://localhost:${localDevPort}${window.location.pathname}${window.location.search}`
  );
}

const Main: React.FC = () => {

  return (
    <RumErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </RumErrorBoundary>
  )
}

// ReactDOM.(<Main />, document.getElementById('root'))

const root = createRoot(document.getElementById('root')!);   // notice the '!'
root.render(<Main />);